import styled from 'styled-components';

import { Components, FontFamily, ThemeProps as Prop } from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.BUTTON;

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  ${() => getFontStyles(FontFamily.SECONDARY_FONT, undefined, undefined, undefined, CPNT, 'button')};
  padding: 16px 20px;
  background-color: ${({ $colorProfile, $colors }) => (($colors) ? $colors.BTN_BG : themeUtil(Prop.BTN_BG, CPNT, $colorProfile))};
  color: ${({ $colorProfile, $colors }) => (($colors) ? $colors.BTN_TXT : themeUtil(Prop.BTN_TXT, CPNT, $colorProfile))};
  transition: color 0.25s ease-out, background-color 0.25s ease-out;

  ${({ disabled, $colorProfile, $colors }) => (disabled ? `
    cursor: default;
    opacity: .5;
  ` : `
    &:hover, &:focus {
      transition: color 0.25s ease-out, background-color 0.25s ease-out;
      background-color: ${(($colors) ? $colors.BTN_BG_HOVER : themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile))};
      color: ${(($colors) ? $colors.BTN_TXT_HOVER : themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile))};
    }
    &:focus {
      outline: 2px solid ${(($colors) ? $colors.BTN_BG_HOVER : themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile))};
      outline-offset: 0.2em;
    }
  `)};
`;
